export default __webpack_public_path__ + "static/media/Place-des-tendance.de521ab3.png";